import styles from '../../styles/pages/index.module.scss';
import { getFaqs } from '../api/cms';
import CustomHead from '../components/CustomHead';
import FaqsLayout from '../components/FaqsLayout/FaqsLayout';
import Footer from '../components/Footer/Footer';
import Header from '../components/Header/Header';
import Navigation from '../components/Navigation/Navigation';
import PageTitle from '../components/Page Title/PageTitle';
import { getOrFetchFooterLinks } from '../utils/footerLinks';
import { getOrFetchNavigationLinks } from '../utils/navigationLinks';

export default function Faqs({ data, footerLinks, navigation }) {
  return (
    <>
      <header className={styles.headerContainer}>
        <Header navigation={navigation} />
        <Navigation navigation={navigation} />
      </header>
      <CustomHead title="Συχνές Ερωτήσεις" key="title" />
      <PageTitle title="Συχνές Ερωτήσεις" />
      <FaqsLayout faqCategories={data} />
      <Footer footerLinks={footerLinks} />
    </>
  );
}

export async function getStaticProps() {
  const [{ data }, footerLinks, { data: navigation }] = await Promise.all([
    getFaqs(),
    getOrFetchFooterLinks(),
    getOrFetchNavigationLinks(),
  ]);
  return {
    props: {
      data,
      footerLinks,
      navigation,
    },
  };
}
